export type LeadershipMember = {
  name: string;
  title: string;
  bio: string;
  location: string;
  img: string;
  imageScale?: number;
  imageTranslateY?: string;
  profile?: string[];
  quote?: string;
  strategicFocus?: string[];
};

export const leadershipMembers: LeadershipMember[] = [
  {
    name: "J. David Washington",
    title: "Founder & Business Lead",
    bio: "Founder and business lead associated with 7 Hills Development Group, LLC, guiding the strategic vision behind Harambee Global Ventures.",
    location: "7 Hills Development Group, LLC",
    img: "/assets/images/site/headshots/david-washington.png",
  },
  {
    name: "Shae Rodriguez",
    title: "Executive Vice President",
    bio: "Shae Rodriguez serves as Executive Vice President of Harambee Global Ventures, where she leads strategic growth initiatives, cultivates high-value partnerships, and helps transform emerging opportunities into scalable business ventures.",
    location: "Harambee Global Ventures",
    img: "/assets/images/site/headshots/shae-rodriguez-reframed.png",
    imageScale: 1.12,
    imageTranslateY: "5.5%",
    profile: [
      "With a background spanning business development, digital commerce, marketing, operational strategy, and corporate relationship management, Shae brings a unique ability to connect vision with execution. She has led multimillion-dollar business portfolios, developed digital revenue channels, supported complex enterprise relationships, and built strategies designed to strengthen market position and accelerate sustainable growth.",
      "At Harambee, Shae works across the firm's ecosystem to identify opportunities where capital, industry expertise, strategic relationships, and market access can create mutual value. Her focus extends beyond individual transactions to building long-term partnerships between businesses, investors, institutions, and other stakeholders whose capabilities can be stronger together.",
      "Known for seeing both the commercial opportunity and the pathway required to execute it, Shae brings a forward-thinking perspective to growth strategy, go-to-market development, digital transformation, brand positioning, and operational execution.",
      "Shae also serves on the Board of Directors of TWST4Girls as Director of Operations, extending her leadership into nonprofit governance and initiatives that expand educational, professional, and global opportunities for young women.",
    ],
    quote: "The most valuable partnerships don't just connect organizations, they connect the right people, resources, and opportunities at the right time to create something bigger.",
    strategicFocus: [
      "Strategic Partnerships",
      "Business Development",
      "Growth Strategy",
      "Corporate Relations",
      "Digital Commerce",
      "Go-to-Market Strategy",
      "Operational Execution",
    ],
  },
  {
    name: "Yolonda R. Kelley, PMP®",
    title: "Executive Vice President of Global Business Development",
    bio: "Yolonda R. Kelley is a certified Project Management Professional with over 25 years of experience leading complex international initiatives, large-scale EdTech implementations, and cross-functional teams.",
    location: "Harambee Global Ventures",
    img: "/assets/images/site/headshots/yolonda.webp",
    profile: [
      'A "master connector," Yolonda has managed global portfolios exceeding $50 million, maintained a 100% contract execution rate across full project life cycles, and translated high-level corporate visions into localized, high-value market penetration strategies.',
      "Her expertise spans international expansion, revenue streams, enterprise stakeholder negotiations, fiscal and portfolio management, digital transformation, data analysis frameworks, and adult learning and training. She also brings experience in public-private partnerships and cross-regional community and workforce development.",
      "Alongside her role at Harambee Global Ventures, her professional experience includes CEO and Managing Director of FRFL Management Group; Vice President of Family Roots For Life, Inc.®; Sales Account Executive at Savvas Learning Company; and Senior Product Manager, International Solutions and Manager for Professional Services at Houghton Mifflin Harcourt.",
      "Her background also includes serving as a Technical Assistance Provider for the Texas Education Agency, COO and Co-Founder of THIRST Teacher Training, and Director of Curriculum, Instruction and Assessment at The Pro-Vision Academy.",
      "Known as The Griot Cowgirl, Yolonda is a historical preservationist specializing in record synthesis and data analysis to preserve historical and cultural legacies for civic and corporate organizations.",
    ],
    strategicFocus: [
      "Global Business Development",
      "Fiscal & Portfolio Management",
      "EdTech & Curricular Strategy",
      "Ecosystem & Diaspora Alignment",
    ],
  },
  {
    name: "Tamara Thomas",
    title: "Chief Operating Officer",
    bio: "As Chief Operating Officer, Tamara Thomas leads Harambee's day-to-day operations and helps turn the organization's strategy into action.",
    location: "Harambee Global Ventures",
    img: "/assets/images/site/headshots/tamara-thomas.webp",
  },
  {
    name: "Kenyatta BaRaKa",
    title: "Chief Information Officer",
    bio: "As Chief Information Officer, Kenyatta BaRaKa leads Harambee's technology strategy and helps shape the systems that support its work across markets.",
    location: "Nairobi, Kenya",
    img: "/assets/images/site/headshots/kenyatta-baraka.webp",
  },
  {
    name: "Emily Anderson, PE, P.Eng., PMP",
    title: "Advisory Team Member",
    bio: "Engineering and project management professional based in Houston, Texas, supporting execution, planning, and delivery discipline across the platform.",
    location: "Houston, Texas",
    img: "/assets/images/site/headshots/emily-anderson.webp",
  },
  {
    name: "Dr. Daniel Moses",
    title: "Advisory Team Member",
    bio: "Real estate developer, lecturer, and author based in London, bringing cross-border business and market development experience to the advisory team.",
    location: "London, United Kingdom",
    img: "/assets/images/site/placeholder-temp.svg",
  },
  {
    name: "Ambassador Dr. Thomas Kwaka",
    title: "Advisory Team Member",
    bio: "Attorney and former U.S. Ambassador for Kenya, offering legal, diplomatic, and cross-border strategic perspective from Nairobi.",
    location: "Nairobi, Kenya",
    img: "/assets/images/site/placeholder-temp.svg",
  },
  {
    name: "Dr. Charlie Kamotho",
    title: "Advisory Team Member",
    bio: "Healthcare entrepreneur and physician leader, listed in the business plan advisory team as founder and CEO of Daktari Africa.",
    location: "Daktari Africa",
    img: "/assets/images/site/placeholder-temp.svg",
  },
];
